import * as React from "react";
import { useState, useEffect } from "react";
import "../../css/offhiremodal.css";
import {
  fetchOffHireData,
  postOffHireRequest,
} from "../../features/Voyage/VoyageSlice";
import { getPortNames } from "../../features/RawData/RawDataSlice";
import { useDispatch, useSelector } from "react-redux";
import {Form, Table, Input, Descriptions, Button, Modal, DatePicker, Select } from "antd";
const { Option } = Select;
const OffHireModal = ({ open, handleClose, casper_id, imoNumber, data }) => {
  const { offHireData } = useSelector((state) => state.voyage);
  const { portSuggestions } = useSelector((state) => state.rawData);
  const dispatch = useDispatch();
  const [fuelData, setFuelData] = useState({});
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [initialFuelData, setInitialFuelData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [identifier, setIdentifier] = useState(offHireData?.identifier || '');
  const [portValues, setPortValues] = useState({
    from_port : offHireData?.from_port,
    to_port: offHireData?.to_port,
    to_port_code: offHireData?.to_port_code,
    from_port_code: offHireData?.from_port_code
  });
  const [startDate, setStartDate] = useState(offHireData?.start_date || null);
const [endDate, setEndDate] = useState(offHireData?.end_date || null);
  const [form] = Form.useForm();
  useEffect(() => {
    const formattedData = offHireData?.consumption?.map((item) => ({
      key: item.fuel_factor.id,
      fuel_name: item.fuel_name,
      class_name: item.class_name,
      consumption: item.consumption,
      lcv: item.fuel_factor.lcv?.toFixed(2),
      cslip: item.fuel_factor.cslip,
      ef_ttw_MJfuel: item.fuel_factor.ef_ttw_MJfuel?.toFixed(2),
      ef_ttw_gfuel: item.fuel_factor.ef_ttw_gfuel?.toFixed(2),
      ef_wtt_MJfuel: item.fuel_factor.ef_wtt_MJfuel?.toFixed(2),
      ef_wtt_gfuel: item.fuel_factor.ef_wtt_gfuel?.toFixed(2),
      rwdi: item.fuel_factor.rwdi,
    }));
    setFuelData(formattedData);
    setInitialFuelData(formattedData);
  }, [offHireData]);

  const handleConsumptionChange = (value, key) => {
    setFuelData((prev) => {
      const updatedData = prev.map((row) =>
        row.key === key ? { ...row, consumption: value } : row
      );

      // Check if there's any change compared to the initial data
      const hasChanges = updatedData.some(
        (row, index) => row.consumption !== initialFuelData[index]?.consumption
      );
      setIsSaveEnabled(hasChanges);

      return updatedData;
    });
  };

  const columns = [
    {
      title: "Fuel Name",
      dataIndex: "fuel_name",
      key: "fuel_name",
    },
    {
      title: "Fuel Class",
      dataIndex: "class_name",
      key: "class_name",
    },
    {
      title: "Consumption(MT)",
      dataIndex: "consumption",
      key: "consumption",
      width: 120,
      render: (text, record) => {
        const isChanged =
          record.consumption !==
          initialFuelData.find((item) => item.key === record.key)?.consumption;
        return (
          <Input
            style={{
              width: "90%",
              backgroundColor: isChanged ? "#daecf8" : "white",
            }}
            value={record.consumption}
            onChange={(e) => handleConsumptionChange(e.target.value, record.key)}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                ".",
              ];
              const isNumber = e.key >= "0" && e.key <= "9";

              if (!isNumber && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        );
      },
    },
    {
      title: "LCV(MJ/MT)",
      dataIndex: "lcv",
      key: "lcv",
    },
    {
      title: "Cslip",
      dataIndex: "cslip",
      key: "cslip",
    },
    {
      title: "EF-TTW (MJfuel)",
      dataIndex: "ef_ttw_MJfuel",
      key: "ef_ttw_MJfuel",
    },
    {
      title: "EF-TTW (Gfuel)",
      dataIndex: "ef_ttw_gfuel",
      key: "ef_ttw_gfuel",
    },
    {
      title: "EF-WTT (MJfuel)",
      dataIndex: "ef_wtt_MJfuel",
      key: "ef_wtt_MJfuel",
    },
    {
      title: "EF-WTT (Gfuel)",
      dataIndex: "ef_wtt_gfuel",
      key: "ef_wtt_gfuel",
    },
    {
      title: "RWDi",
      dataIndex: "rwdi",
      key: "rwdi",
    },
  ];

  const generalDetails = [
    { label: "Casper ID", key: "casper_id" },
    { label: "IMO Number", key: "imo_number" },
    { label: "Total Cargo On Board (MT)", key: "total_cargo_on_board_mt" },
    { label: "Start Date", key: "start_date", input: "date" },
    { label: "End Date", key: "end_date", input: "date" },
  ];

  const generalDetailsIdentifier = [
    { label: "From Port", key: "from_port", input: 'dropdown' },
    { label: "To Port", key: "to_port", input: 'dropdown' },
    { label: "Identifier", key: "identifier" },
  ];

  const handleSave = async () => {
     const transformedPayload = fuelData.map((item) => ({
      fuel_factor: [{
        id: item.key, // Use the key as the id
        lcv: parseFloat(item.lcv) || 0,
        cslip: item.cslip || 0,
        ef_ttw_MJfuel: parseFloat(item.ef_ttw_MJfuel) || 0,
        ef_ttw_gfuel: parseFloat(item.ef_ttw_gfuel) || 0,
        ef_wtt_MJfuel: parseFloat(item.ef_wtt_MJfuel) || 0,
        ef_wtt_gfuel: parseFloat(item.ef_wtt_gfuel) || 0,
        rwdi: item.rwdi || 0,
      }],
      fuel_name: item.fuel_name,
      fuel_class: item.class_name,
      consumption: parseFloat(item.consumption) || 0, // Default to 0 if empty
    }));

    const payload = {
      deadweight: offHireData.deadweight,
      pwind: offHireData.pwind,
      pprop: offHireData.pprop,
      vessel_type: offHireData.vessel_type,
      casper_id: offHireData.casper_id,
      to_port_code: portValues?.to_port_code || "",
      from_port_code: portValues?.from_port_code || "",
      to_port: portValues?.to_port || "",
      from_port: portValues?.from_port || "",
      identifier: identifier,
      cargo_weight: offHireData.cargo_weight,
      consumption: transformedPayload,
      imo_number: imoNumber,
      voyage_start_date: startDate || '',
      voyage_end_date: endDate || '',
      distance: offHireData.distance,
    };

    dispatch(postOffHireRequest(payload));
    handleClose();
  };

  const handleSearch = (value) => {
    const uppercasedValue = value.toUpperCase();
    setSearchValue(uppercasedValue);
    if (uppercasedValue.length >= 3) {
      dispatch(getPortNames(uppercasedValue));
    }
  };


  const handleKeyDown = (event) => {
    if (event.key.length === 1 && /^[a-zA-Z]$/.test(event.key)) {
      event.preventDefault();
      const uppercasedKey = event.key.toUpperCase();
      const newValue = searchValue + uppercasedKey;
      setSearchValue(newValue);
      if (newValue.length >= 3) {
        dispatch(getPortNames(newValue));
      }
    } else if (event.key === 'Backspace') {
      const newValue = searchValue.slice(0, -1);
      setSearchValue(newValue);
    }
  };

  const handlePortChange = (value, portDetail) => {
    const selectedPort = portSuggestions.find(port => port.port_name === value);
    const newPortName = selectedPort?.identifier || '';
      setPortValues({ ...portValues, [portDetail]: value || "", [`${portDetail}_code`]: selectedPort?.port_code || "" });
      setIsSaveEnabled(true)
      setIdentifier(prevIdentifier => {
        const parts = prevIdentifier.split('-');
        if (portDetail === 'from_port') {
          // Replace the starting part
          return `${newPortName}-${parts[1] || ''}`;
        } else if (portDetail === 'to_port') {
          // Replace the ending part
          return `${parts[0] || ''}-${newPortName}`;
        }
        return prevIdentifier;
      });
  };
  const handleDateChange = (date, dateString, key) => {
    if (key === "start_date") {
      setStartDate(date); // Update start_date state
    } else if (key === "end_date") {
      setEndDate(date); // Update end_date state
    }
    setIsSaveEnabled(true)
    console.log(`${key} updated to ${dateString}`);
  };

  return (
    <Modal
      title="Off Hire Data"
      open={open}
      onCancel={handleClose}
      footer={[<div className='fuel-edit-modal-footer'>
        <div className='fuel-edit-modal-footer-remark'>
          <span>*Only consumption can be edited!</span>
        </div>
        <div className='fuel-edit-modal-footer-buttons'>
          <Button key="cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className={isSaveEnabled ? "" : "off-hire-save"} key="save" type="primary" onClick={handleSave} disabled={!isSaveEnabled} >
            Save
          </Button>
        </div>
      </div>
      ]}
      className="fuel-edit-modal"
      style={{ top: 50 }}
    >
      <h3>General Details</h3>
      <Descriptions className="offhire-description-table" bordered column={5} layout="vertical">
        {generalDetails.map((item) => (
          <Descriptions.Item label={item.label} key={item.key}>
            {item.input === "date" ? (
              <DatePicker
              value={item.key === "start_date" ? startDate : endDate}
              onChange={(date, dateString) => handleDateChange(date, dateString, item.key)}
                style={{ width: "100%" }}
              />
            ) : (
              offHireData?.[item.key] || "N/A"
            )}
          </Descriptions.Item>
        ))}
      </Descriptions>
      <Descriptions className="offhire-description-table" bordered column={3} layout="vertical">
        {generalDetailsIdentifier.map((item) => (
          <Descriptions.Item label={item.label} key={item.key}>
            {item.input === "dropdown" ? (
              <Select
              showSearch
              value={portValues?.[item.key] || ''}
              onSearch={handleSearch}
              onChange={(value) => handlePortChange(value, item.key)}
              filterOption={false}
              searchValue={searchValue}
              onInputKeyDown={handleKeyDown}
              style={{ width: "100%" }}
            >
              {portSuggestions?.map((port) => (
                      <Option key={port.port_name} value={port.port_name}>
                          {port.port_name}
                      </Option>
                  ))}
            </Select>
            ) : (
              identifier || offHireData?.[item.key] || "N/A"
            )}
          </Descriptions.Item>
        ))}
      </Descriptions>


      <h3 style={{ margin: "10px 0" }}>Fuel Details</h3>
      <Table
        dataSource={fuelData}
        columns={columns}
        pagination={false}
        bordered
        className="fuel-data-stepper-table offhire-table"
      />
    </Modal>
  );
};

export default OffHireModal;
